import styled from "styled-components";

export const Wrapper = styled.svg`
  display: block;
`;
